<template>
  <server-table-component 
    table="set_relation" schema="sch_set_relation"
  ></server-table-component>
</template>

<script>
// import CartWrapper from "@/library/CartWrapper";
import TaxExample from "../../components/settings/TaxExample";
import { sync } from "vuex-pathify";
// import axios from "axios";
import axiosInstances from '@/../../coreui/server/axiosInstances'
export default {
  components: {
    // CartWrapper,
    TaxExample
  },
  data() {
    return {
      rateData: [],
      usStates: [],
      taxStyle: null,
    };
  },
  computed: {
    dialogFunctions: sync("dialogFunctions"),
    rows: sync("tableRows"),
    secondDialogEnabled: sync("secondDialogEnabled"),
    arrayEditTable: sync("arrayEditTable"),
    secondDialogComponent: sync("secondDialogComponent"),
    topItems: sync("savedDialogState")
  },
  watch: {
    arrayEditTable: {
      handler(newValue) {
        console.log("arrayEditTable = ", newValue);
        this.secondDialogEnabled = newValue;
      },
      deep: true
    }
  },
  methods: {
    validate(val, that) {
      let rowCount = this.rows.length;
      console.log("Start Validation, tax style = ", this.taxStyle);
      for (let i = 0; i < rowCount; i++) {
        if (this.isUndefined(this.rows[0].name)) {
          this.taxStyle = null;
        }
        if (!this.isEmptyString(this.rows[i].name)) {
          const [name, rate, unit, usState] = this.getRateParameters(
            this.rows[i].name
          );
          if (!this.isNull(name)) {
            if (this.isNull(this.taxStyle)) this.taxStyle = unit;
            else {
              if (this.taxStyle != unit) {
                this.taxStyleError(unit);
              }
            }
            this.checkSpecialRegimen(name);
            this.rows[i].rate = rate + " " + unit;
          }
        }
      }
      return true;
    },
    async fetchData() {
      let temp = await axiosInstances.apiServer.get("/dt/v1/set_tax");
      let tempUS = await axiosInstances.apiServer.get("dt/v1/usstate");
      this.rateData = temp.data;
      this.usStates = tempUS.data;
    },
    taxStyleError(val) {
      let currentStyle = "";
      let latestStyle = "";
      console.log("Tax Style = ", this.taxStyle);
      console.log("New Style = ", val);
      if (this.taxStyle === "%") currentStyle = "percentage based";
      else currentStyle = "weight based";
      if (val === "%") latestStyle = "percentage based";
      else latestStyle = "weight based";
      this.$root
        .$confirm(
          "Tax Type Mismatch",
          "This tax relationship uses " +
            currentStyle +
            " taxation. The last added tax uses " +
            latestStyle +
            " taxation.\n\nThese types of taxes cannot be part of the same relationship.\n\nDo you want to delete the last added tax?",
          {
            color: "red",
            width: "350"
          }
        )
        .then(confirm => {
          if (confirm) {
            this.rows.pop();
            console.log("User Clicked Yes");
          }
        });
    },
    checkSpecialRegimen(val) {
      let regimen = null;
      if (this.isNull(this.topItems)) {
        regimen = "None";
      } else {
        regimen = this.isEmptyString(this.topItems.dialogEditedItem.cond)
          ? "None"
          : this.topItems.dialogEditedItem.cond;
      }
      if(val === "CDFTA Markup"){
        if(regimen != 'CA Arm\'s Length'){
          console.log("ERROR NEEDS TAX REGIMEN")
        }
      }
      console.log("Regimen = ", regimen);
    },
    getRateParameters(val) {
      let name = null;
      let rate = null;
      let unit = null;
      let usState = null;
      if (!this.isUndefined(val)) {
        let rateOBJ = this.rateData.find(x => x["_id"] === val);
        if (!this.isUndefined(rateOBJ)) {
          name = rateOBJ.name;
          rate = rateOBJ.rate;
          unit = rateOBJ.unit;
          usState = rateOBJ.state;
        }
      }
      return [name, rate, unit, usState];
    },
    isEmptyString(arg) {
      if (!this.isNull(arg) && !this.isUndefined(arg)) {
        let testString = String(arg);
        return !testString.trim();
      }
      return false;
    },
    isNull(arg) {
      return arg === null;
    },
    isUndefined(arg) {
      return arg === undefined;
    }
  },
  mounted() {
    this.dialogFunctions.validate = this.validate;
    this.secondDialogComponent = TaxExample;
    this.fetchData();
  }
};
</script>

